import logo from '../img/smoothaffairs-logo.png';
import black from '../img/smoothaffairs-black.png';
import ImageWrapper from './ImageWrapper';
import { useState } from 'react';
import { navbar } from '../utils/menus';
import SidebarLink from '../components/SidebarLink';
import Icon from './Icon';
import Button from './Button';

function Navbar() {
    const [open, toggleSidebar] = useState(false);
    const [scrollY, setScrollY] = useState(window.scrollY > 100);
    window.addEventListener('scroll', () => {
        if (window.scrollY > 100) setScrollY(true);
        else setScrollY(false);
    });

    return (
        <div
            className={`sticky top-0 ${
                open ? 'bg-white' : 'bg-body'
            } z-[99] w-full flex justify-between items-center py-8 lg:px-8`}>
            <div className="page__width relative flex items-center justify-between">
                <div className="flex items-center gap-8">
                    <a href="/">
                        <ImageWrapper
                            src={open?black:logo}
                            alt="Logo"
                            className="w-32 py-2"
                        />
                    </a>
                    <div className="hidden lg:flex items-center gap-8">
                        {navbar.map((link, i) => {
                            return (
                                <>
                                    {link.submenu ? (
                                        <SidebarLink
                                            key={i}
                                            sublinks={link.submenu}
                                            scrollY={scrollY}
                                            href={link.href}>
                                            {link.label}
                                        </SidebarLink>
                                    ) : (
                                        <a
                                            key={i}
                                            href={link.href}
                                            className={`animated_link relative block text-sm`}>
                                            {link.label}
                                        </a>
                                    )}
                                </>
                            );
                        })}
                    </div>
                </div>
                <Button additionalStyles='hidden lg:flex' href="/contact">Get In Touch</Button>
                <button
                    className="lg:hidden"
                    onClick={() => toggleSidebar(!open)}>
                    {open ? (
                        <Icon
                            name="x-icon"
                            className="w-6 h-6 mr-8"
                        />
                    ) : (
                        <Icon
                            name="burger"
                            className={`w-6 h-6 mr-8 text-white`}
                        />
                    )}
                </button>
            </div>
            <div
                className={`absolute left-0 top-full duration-200 transition-all bg-white justify-between w-full z-[99] overflow-y-hidden lg:hidden ${
                    open ? 'h-auto pb-4' : 'h-0'
                }`}>
                <div className="flex flex-col items-start">
                    {navbar.map((link, i) => {
                        return (
                            <>
                                {link.submenu ? (
                                    <SidebarLink
                                        key={i}
                                        sublinks={link.submenu}
                                        href={link.href}>
                                        {link.label}
                                    </SidebarLink>
                                ) : (
                                    <a
                                        key={i}
                                        href={link.href}
                                        className="px-[7.5%] block w-full text-base text-black py-4 transition-all duration-200">
                                        {link.label}
                                    </a>
                                )}
                            </>
                        );
                    })}
                    <div className='page__width flex items-center justify-center'>
                        <Button href="/contact">Get In Touch</Button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Navbar;
